import { useMemo } from 'react'

import { createOpeEquipmentValidator } from 'form/fields/opeEquipmentFields'

import useOpeCollateralLimits from './useOpeCollateralLimits'

export default function useOpeEquipmentValidator(enabled = true) {
    const { maxItems, isLoading } = useOpeCollateralLimits(enabled)

    return useMemo(
        () => createOpeEquipmentValidator(isLoading ? undefined : maxItems),
        [isLoading, maxItems],
    )
}
